import { supabase } from '../../supabaseClient'
import { useNavigate } from 'react-router-dom'

export default function LogoutButton() {
  const navigate = useNavigate()

  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('admin/login')
  }

  return (
    <button
      onClick={handleLogout}
      style={{
        padding: '10px 16px',
        borderRadius: '8px',
        border: 'none',
        background: '#dc3545',
        color: '#fff',
        cursor: 'pointer',
        marginTop: 'auto'
      }}
    >
      Logout
    </button>
  )
}
